module.exports = "<prg-notification-parameters></prg-notification-parameters>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/email-notification/email-notification.component.html
// module id = 1586
// module chunks = 2